/* tslint:disable */
/* eslint-disable */
/**
 * Onibi Portal Api
 * The API for the OnibiPortal Server project
 *
 * OpenAPI spec version: v1
 * Contact: info@yumebau.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { StoreImageType } from '../models';
import { StoreImageTypeDto } from '../models';
import { StoreItemDto } from '../models';
import { StoreItemDtoPagedResponse } from '../models';
/**
 * StoreItemCreationApi - axios parameter creator
 * @export
 */
export const StoreItemCreationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<Blob>} [inGameThumbnails] 
         * @param {string} [storeItemDtoString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStoreItemCreationCreatePostForm: async (inGameThumbnails?: Array<Blob>, storeItemDtoString?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StoreItemCreation/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (inGameThumbnails) {
                inGameThumbnails.forEach((element) => {
                    localVarFormParams.append('InGameThumbnails', element as any);
                })
            }

            if (storeItemDtoString !== undefined) { 
                localVarFormParams.append('StoreItemDtoString', storeItemDtoString as any);
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StoreImageTypeDto} [body] 
         * @param {string} [server] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStoreItemCreationCreateStoreImageTypePost: async (body?: StoreImageTypeDto, server?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StoreItemCreation/createStoreImageType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {string} [id] 
         * @param {boolean} [permanent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStoreItemCreationDeleteDelete: async (server?: string, id?: string, permanent?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StoreItemCreation/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            if (id !== undefined) {
                localVarQueryParameter['Id'] = id;
            }

            if (permanent !== undefined) {
                localVarQueryParameter['permanent'] = permanent;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStoreItemCreationDeleteStoreImageTypeDelete: async (server?: string, id?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StoreItemCreation/deleteStoreImageType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            if (id !== undefined) {
                localVarQueryParameter['Id'] = id;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<Blob>} [inGameThumbnails] 
         * @param {string} [storeItemDtoString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStoreItemCreationEditPostForm: async (inGameThumbnails?: Array<Blob>, storeItemDtoString?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StoreItemCreation/edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (inGameThumbnails) {
                inGameThumbnails.forEach((element) => {
                    localVarFormParams.append('InGameThumbnails', element as any);
                })
            }

            if (storeItemDtoString !== undefined) { 
                localVarFormParams.append('storeItemDtoString', storeItemDtoString as any);
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StoreImageType} [body] 
         * @param {string} [server] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStoreItemCreationEditStoreImageTypePost: async (body?: StoreImageType, server?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StoreItemCreation/editStoreImageType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {number} [page] 
         * @param {number} [itemsPerPage] 
         * @param {string} [orderBy] 
         * @param {boolean} [sortDesc] 
         * @param {string} [category] 
         * @param {boolean} [isDeleted] 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStoreItemCreationGetGet: async (server?: string, page?: number, itemsPerPage?: number, orderBy?: string, sortDesc?: boolean, category?: string, isDeleted?: boolean, searchTerm?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StoreItemCreation/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (sortDesc !== undefined) {
                localVarQueryParameter['sortDesc'] = sortDesc;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (isDeleted !== undefined) {
                localVarQueryParameter['isDeleted'] = isDeleted;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStoreItemCreationGetStoreImageTypesGet: async (server?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StoreItemCreation/getStoreImageTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {string} [itemToMove] 
         * @param {number} [newPriority] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStoreItemCreationTop30Get: async (server?: string, itemToMove?: string, newPriority?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StoreItemCreation/top30`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            if (itemToMove !== undefined) {
                localVarQueryParameter['itemToMove'] = itemToMove;
            }

            if (newPriority !== undefined) {
                localVarQueryParameter['newPriority'] = newPriority;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StoreItemCreationApi - functional programming interface
 * @export
 */
export const StoreItemCreationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<Blob>} [inGameThumbnails] 
         * @param {string} [storeItemDtoString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStoreItemCreationCreatePostForm(inGameThumbnails?: Array<Blob>, storeItemDtoString?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<StoreItemDto>>> {
            const localVarAxiosArgs = await StoreItemCreationApiAxiosParamCreator(configuration).apiStoreItemCreationCreatePostForm(inGameThumbnails, storeItemDtoString, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {StoreImageTypeDto} [body] 
         * @param {string} [server] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStoreItemCreationCreateStoreImageTypePost(body?: StoreImageTypeDto, server?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<StoreImageType>>> {
            const localVarAxiosArgs = await StoreItemCreationApiAxiosParamCreator(configuration).apiStoreItemCreationCreateStoreImageTypePost(body, server, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {string} [id] 
         * @param {boolean} [permanent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStoreItemCreationDeleteDelete(server?: string, id?: string, permanent?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await StoreItemCreationApiAxiosParamCreator(configuration).apiStoreItemCreationDeleteDelete(server, id, permanent, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStoreItemCreationDeleteStoreImageTypeDelete(server?: string, id?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await StoreItemCreationApiAxiosParamCreator(configuration).apiStoreItemCreationDeleteStoreImageTypeDelete(server, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {Array<Blob>} [inGameThumbnails] 
         * @param {string} [storeItemDtoString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStoreItemCreationEditPostForm(inGameThumbnails?: Array<Blob>, storeItemDtoString?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<StoreItemDto>>> {
            const localVarAxiosArgs = await StoreItemCreationApiAxiosParamCreator(configuration).apiStoreItemCreationEditPostForm(inGameThumbnails, storeItemDtoString, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {StoreImageType} [body] 
         * @param {string} [server] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStoreItemCreationEditStoreImageTypePost(body?: StoreImageType, server?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<StoreImageType>>> {
            const localVarAxiosArgs = await StoreItemCreationApiAxiosParamCreator(configuration).apiStoreItemCreationEditStoreImageTypePost(body, server, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {number} [page] 
         * @param {number} [itemsPerPage] 
         * @param {string} [orderBy] 
         * @param {boolean} [sortDesc] 
         * @param {string} [category] 
         * @param {boolean} [isDeleted] 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStoreItemCreationGetGet(server?: string, page?: number, itemsPerPage?: number, orderBy?: string, sortDesc?: boolean, category?: string, isDeleted?: boolean, searchTerm?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<StoreItemDtoPagedResponse>>> {
            const localVarAxiosArgs = await StoreItemCreationApiAxiosParamCreator(configuration).apiStoreItemCreationGetGet(server, page, itemsPerPage, orderBy, sortDesc, category, isDeleted, searchTerm, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStoreItemCreationGetStoreImageTypesGet(server?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<StoreImageType>>> {
            const localVarAxiosArgs = await StoreItemCreationApiAxiosParamCreator(configuration).apiStoreItemCreationGetStoreImageTypesGet(server, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {string} [itemToMove] 
         * @param {number} [newPriority] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStoreItemCreationTop30Get(server?: string, itemToMove?: string, newPriority?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<StoreItemDtoPagedResponse>>> {
            const localVarAxiosArgs = await StoreItemCreationApiAxiosParamCreator(configuration).apiStoreItemCreationTop30Get(server, itemToMove, newPriority, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * StoreItemCreationApi - factory interface
 * @export
 */
export const StoreItemCreationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {Array<Blob>} [inGameThumbnails] 
         * @param {string} [storeItemDtoString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStoreItemCreationCreatePostForm(inGameThumbnails?: Array<Blob>, storeItemDtoString?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<StoreItemDto>> {
            return StoreItemCreationApiFp(configuration).apiStoreItemCreationCreatePostForm(inGameThumbnails, storeItemDtoString, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StoreImageTypeDto} [body] 
         * @param {string} [server] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStoreItemCreationCreateStoreImageTypePost(body?: StoreImageTypeDto, server?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<StoreImageType>> {
            return StoreItemCreationApiFp(configuration).apiStoreItemCreationCreateStoreImageTypePost(body, server, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [server] 
         * @param {string} [id] 
         * @param {boolean} [permanent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStoreItemCreationDeleteDelete(server?: string, id?: string, permanent?: boolean, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return StoreItemCreationApiFp(configuration).apiStoreItemCreationDeleteDelete(server, id, permanent, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [server] 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStoreItemCreationDeleteStoreImageTypeDelete(server?: string, id?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return StoreItemCreationApiFp(configuration).apiStoreItemCreationDeleteStoreImageTypeDelete(server, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<Blob>} [inGameThumbnails] 
         * @param {string} [storeItemDtoString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStoreItemCreationEditPostForm(inGameThumbnails?: Array<Blob>, storeItemDtoString?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<StoreItemDto>> {
            return StoreItemCreationApiFp(configuration).apiStoreItemCreationEditPostForm(inGameThumbnails, storeItemDtoString, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StoreImageType} [body] 
         * @param {string} [server] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStoreItemCreationEditStoreImageTypePost(body?: StoreImageType, server?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<StoreImageType>> {
            return StoreItemCreationApiFp(configuration).apiStoreItemCreationEditStoreImageTypePost(body, server, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [server] 
         * @param {number} [page] 
         * @param {number} [itemsPerPage] 
         * @param {string} [orderBy] 
         * @param {boolean} [sortDesc] 
         * @param {string} [category] 
         * @param {boolean} [isDeleted] 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStoreItemCreationGetGet(server?: string, page?: number, itemsPerPage?: number, orderBy?: string, sortDesc?: boolean, category?: string, isDeleted?: boolean, searchTerm?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<StoreItemDtoPagedResponse>> {
            return StoreItemCreationApiFp(configuration).apiStoreItemCreationGetGet(server, page, itemsPerPage, orderBy, sortDesc, category, isDeleted, searchTerm, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [server] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStoreItemCreationGetStoreImageTypesGet(server?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<StoreImageType>> {
            return StoreItemCreationApiFp(configuration).apiStoreItemCreationGetStoreImageTypesGet(server, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [server] 
         * @param {string} [itemToMove] 
         * @param {number} [newPriority] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStoreItemCreationTop30Get(server?: string, itemToMove?: string, newPriority?: number, options?: AxiosRequestConfig): Promise<AxiosResponse<StoreItemDtoPagedResponse>> {
            return StoreItemCreationApiFp(configuration).apiStoreItemCreationTop30Get(server, itemToMove, newPriority, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StoreItemCreationApi - object-oriented interface
 * @export
 * @class StoreItemCreationApi
 * @extends {BaseAPI}
 */
export class StoreItemCreationApi extends BaseAPI {
    /**
     * 
     * @param {Array<Blob>} [inGameThumbnails] 
     * @param {string} [storeItemDtoString] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreItemCreationApi
     */
    public async apiStoreItemCreationCreatePostForm(inGameThumbnails?: Array<Blob>, storeItemDtoString?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<StoreItemDto>> {
        return StoreItemCreationApiFp(this.configuration).apiStoreItemCreationCreatePostForm(inGameThumbnails, storeItemDtoString, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {StoreImageTypeDto} [body] 
     * @param {string} [server] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreItemCreationApi
     */
    public async apiStoreItemCreationCreateStoreImageTypePost(body?: StoreImageTypeDto, server?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<StoreImageType>> {
        return StoreItemCreationApiFp(this.configuration).apiStoreItemCreationCreateStoreImageTypePost(body, server, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [server] 
     * @param {string} [id] 
     * @param {boolean} [permanent] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreItemCreationApi
     */
    public async apiStoreItemCreationDeleteDelete(server?: string, id?: string, permanent?: boolean, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return StoreItemCreationApiFp(this.configuration).apiStoreItemCreationDeleteDelete(server, id, permanent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [server] 
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreItemCreationApi
     */
    public async apiStoreItemCreationDeleteStoreImageTypeDelete(server?: string, id?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return StoreItemCreationApiFp(this.configuration).apiStoreItemCreationDeleteStoreImageTypeDelete(server, id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {Array<Blob>} [inGameThumbnails] 
     * @param {string} [storeItemDtoString] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreItemCreationApi
     */
    public async apiStoreItemCreationEditPostForm(inGameThumbnails?: Array<Blob>, storeItemDtoString?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<StoreItemDto>> {
        return StoreItemCreationApiFp(this.configuration).apiStoreItemCreationEditPostForm(inGameThumbnails, storeItemDtoString, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {StoreImageType} [body] 
     * @param {string} [server] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreItemCreationApi
     */
    public async apiStoreItemCreationEditStoreImageTypePost(body?: StoreImageType, server?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<StoreImageType>> {
        return StoreItemCreationApiFp(this.configuration).apiStoreItemCreationEditStoreImageTypePost(body, server, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [server] 
     * @param {number} [page] 
     * @param {number} [itemsPerPage] 
     * @param {string} [orderBy] 
     * @param {boolean} [sortDesc] 
     * @param {string} [category] 
     * @param {boolean} [isDeleted] 
     * @param {string} [searchTerm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreItemCreationApi
     */
    public async apiStoreItemCreationGetGet(server?: string, page?: number, itemsPerPage?: number, orderBy?: string, sortDesc?: boolean, category?: string, isDeleted?: boolean, searchTerm?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<StoreItemDtoPagedResponse>> {
        return StoreItemCreationApiFp(this.configuration).apiStoreItemCreationGetGet(server, page, itemsPerPage, orderBy, sortDesc, category, isDeleted, searchTerm, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [server] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreItemCreationApi
     */
    public async apiStoreItemCreationGetStoreImageTypesGet(server?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<StoreImageType>> {
        return StoreItemCreationApiFp(this.configuration).apiStoreItemCreationGetStoreImageTypesGet(server, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [server] 
     * @param {string} [itemToMove] 
     * @param {number} [newPriority] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreItemCreationApi
     */
    public async apiStoreItemCreationTop30Get(server?: string, itemToMove?: string, newPriority?: number, options?: AxiosRequestConfig) : Promise<AxiosResponse<StoreItemDtoPagedResponse>> {
        return StoreItemCreationApiFp(this.configuration).apiStoreItemCreationTop30Get(server, itemToMove, newPriority, options).then((request) => request(this.axios, this.basePath));
    }
}
